export default {
	state: {
		shops: [
			{
				id: '001',
				street: 'ул. Горького, дом 285',
				point: 'МАГНИТ'
			},
			{
				id: '002',
				street: 'р-н Северный массив, д. 7 В',
				point: 'СОЛНЕЧНЫЙ КРУГ'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getBataysk (state) {
			return state.shops
		}
	}
}